import type { Geography } from './useGeoAreas.ts';

export type AreaKey = 'code' | 'name';

export type AreaChoice = { readonly value: string; readonly label: string };

const sameArea = (left: string, right: string): boolean =>
  left.localeCompare(right, undefined, { sensitivity: 'base' }) === 0;

export const governorateChoicesOf = (geography: Geography | undefined, by: AreaKey): readonly AreaChoice[] =>
  (geography?.governorates ?? []).map((governorate) => ({ value: governorate[by], label: governorate.name }));

export const delegationChoicesOf = (
  geography: Geography | undefined,
  by: AreaKey,
  governorate: string | null,
): readonly AreaChoice[] =>
  (
    geography?.governorates.find((candidate) => governorate !== null && sameArea(candidate[by], governorate))
      ?.delegations ?? []
  ).map((delegation) => ({ value: delegation[by], label: delegation.name }));

export const keepingCurrent = (choices: readonly AreaChoice[], current: string): readonly AreaChoice[] =>
  current === '' || choices.some((choice) => choice.value === current)
    ? choices
    : [{ value: current, label: current }, ...choices];

export const governorateOfDelegation = (
  geography: Geography | undefined,
  by: AreaKey,
  delegation: string,
): string =>
  geography?.governorates.find((governorate) =>
    governorate.delegations.some((candidate) => delegation !== '' && sameArea(candidate[by], delegation)),
  )?.[by] ?? '';
